import { PageHero } from "@/components/site/PageHero";
import { FadeUp, MaskLines, Em, Eyebrow } from "@/components/site/Motion";
import { FlagRow } from "@/components/site/Flags";
import { Brand, BrandInline } from "@/components/site/Logo";
import { SplitCTA } from "@/components/site/SplitCTA";

const CHAPTERS = [
  { n: "i.", h: "the bench", b: "Every good team has one: people with the skill, waiting for the nod. We spent years on the phone with those people. We learned who they were before anyone else did.", cls: "lg:col-span-5" },
  { n: "ii.", h: "two cities, one habit", b: "PITSUS grew up close to American hiring teams. PITSIND grew up in Chennai, close to some of the deepest engineering talent on the planet. Different clocks, same habit: picking up the phone when others let it ring.", cls: "lg:col-span-6 lg:col-start-7 lg:mt-32" },
  { n: "iii.", h: "one jersey", b: <>So we stopped running as two companies and started running as one: <BrandInline />. Two wings, one body, one standard. When one side sleeps, the other is already on the field.</>, cls: "lg:col-span-7 lg:col-start-3" },
];

const Story = () => (
  <section className="px-5 py-24 sm:px-8 lg:py-36" data-testid="story-section">
    <div className="mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-12">
      {CHAPTERS.map((c, i) => (
        <FadeUp key={c.n} delay={i * 0.05} className={c.cls} data-testid={`chapter-${i}`}>
          <span className="font-serif-i text-6xl text-[#FF4D1A]">{c.n}</span>
          <h3 className="font-display mt-2 text-4xl font-bold tracking-[-0.03em] sm:text-5xl">{c.h}</h3>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[#3d3a35] md:text-lg">{c.b}</p>
        </FadeUp>
      ))}
    </div>
  </section>
);

const VALUES = [
  ["answer the phone.", "Speed starts with being reachable. Everything else follows.", "bg-[#FF4D1A] text-white"],
  ["say the true thing.", "Even when 'not yet' or 'not this one' is the answer.", "bg-[#0E0E10] text-[#F1ECE2]"],
  ["finish the play.", "A hire isn't done at the offer letter. It's done when it works.", "bg-[#2234F5] text-white"],
  ["keep the edge.", "Never get comfortable. Comfortable is how the slow ones got slow.", "bg-[#D4FF3D]"],
];

const Values = () => (
  <section className="bg-[#E7E0D2] px-5 py-24 sm:px-8 lg:py-32" data-testid="values-section">
    <div className="mx-auto max-w-[1400px]">
      <Eyebrow className="text-[#c2380f]">house rules</Eyebrow>
      <MaskLines as="h2" lines={["four rules.", <Em>no exceptions.</Em>]} className="font-display mt-6 text-4xl font-bold leading-[0.95] tracking-[-0.03em] sm:text-6xl" />
      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {VALUES.map(([t, b, c], i) => (
          <FadeUp key={t} delay={i * 0.08} className={`flex min-h-[260px] flex-col justify-between p-7 transition-transform duration-500 hover:-translate-y-2 ${c} ${i % 2 ? "lg:mt-14" : ""}`} data-testid={`value-${i}`}>
            <span className="font-mono-x text-xs">rule 0{i + 1}</span>
            <div><h3 className="font-display text-3xl font-bold tracking-tight">{t}</h3><p className="mt-3 text-[0.95rem] leading-relaxed">{b}</p></div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero testid="about-hero" eyebrow={<div className="flex items-center gap-4"><img src="/logo-shield.png" alt="" aria-hidden="true" className="h-10 w-auto" /><Brand size="lg" testid="about-brand" /></div>} lines={["two wings.", "one body.", <Em className="text-[#2234F5]">one direction.</Em>]}
        lead="We weren't the obvious pick. We didn't need to be. We just needed one shot, and the habit of making every one count."
        aside={<div className="flex flex-col gap-3 border-l-2 border-[#0E0E10] pl-6"><FlagRow size="w-7" /><p className="font-mono-x text-sm">pitsus.com · pitsind.com</p></div>} />
      <Story />
      <Values />
      <SplitCTA />
    </div>
  );
}
